<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <p class="detail-content-title">资讯设置</p>

    <el-form label-width="200px">
      <el-form-item label="推荐频道是否推送寻亲：">
        <el-radio v-model="type" label="Y">是</el-radio>
        <el-radio v-model="type" label="N">否</el-radio>
      </el-form-item>
      <el-form-item label="自动热门：">
        <el-radio v-model="hotType" label="1" class="mb10">
          按点击量获取
          <el-input type="number" style="width: 120px;" placeholder="请输入数量"/>
        </el-radio>
        <el-radio v-model="hotType" label="2" class="mb10">
          按评论量获取
          <el-input type="number" style="width: 120px;" placeholder="请输入数量"/>
        </el-radio>
        <el-radio v-model="hotType" label="3" class="mb10">
          按转发量获取
          <el-input type="number" style="width: 120px;" placeholder="请输入数量"/>
        </el-radio>
        <el-radio v-model="hotType" label="4" class="mb10">
          按点赞获取
          <el-input type="number" style="width: 120px;" placeholder="请输入数量"/>
        </el-radio>
      </el-form-item>
      <el-form-item label="频道设置：">
        <el-button type="primary">添加</el-button>
        <el-table class="my-table mt10" :data="tableData" v-loading="tableLoading"
                  :header-row-class-name="'my-table-header'" style="width: 800px;">
          <el-table-column align="center" prop="" label="频道分类"></el-table-column>
          <el-table-column align="center" prop="" label="标签"></el-table-column>
          <el-table-column align="center" prop="" width="200" label="操作">
            <template slot-scope="{row}">
              <a class="glob-a">标签</a>
              <a class="glob-a">编辑</a>
              <a class="glob-a">删除</a>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
  export default {
    name: 'Information',
    data () {
      return {
        type: 'Y',
        hotType: '1',
        tableData: [{1: 1}, {1: 1}, {1: 1}, {1: 1},],
        tableLoading: false
      }
    },
  }
</script>

<style scoped>
  .detail-content-title {
    font-size: 20px;
    font-weight: bold;
    /*padding-top: 30px;*/
    padding-bottom: 15px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
  }
</style>
